import { frontendURL } from '../../../helper/URLHelper';
import MessageLogsIndex from './pages/MessageLogsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/message-logs'),
    name: 'message_logs_index',
    component: MessageLogsIndex,
    meta: {
      // Message content + delivery errors can be sensitive, so this
      // observability tab (custom UAZAPI overlay) is admin-only — same
      // posture as Settings > Audit Logs.
      permissions: ['administrator'],
    },
  },
];
